import styled from 'styled-components';

export const ConfirmDisplayWrapper = styled.div`
  background: ${(props) => props.theme.palette.lightgrey.main};
  height: 100vh;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ConfirmDisplayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.5rem;
  background: ${(props) => props.theme.palette.colors.white};
  padding: 32px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0px 0px 10px 10px rgba(124, 77, 255, 0.25);
`;
